/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-28 09:16:52
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-07-08 11:41:38
 * @FilePath: \vue-hepha-order\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia';

const useLocale = defineStore('locale',{
    state:()=>{
        return {
            lang:'zh',
            clientWidth:'',
            clientHeight:'',
            searchContentDomHeight:'',
        }
    },

    actions:{
        
        changeLocale(val){
            this.lang = val
            // console.log(this.lang,'store2222')
        },

        changeClientWidthAndHeight(width,height){
            this.clientWidth = width
            this.clientHeight = height
            // console.log(this.clientWidth, this.clientHeight, 'store2222')
        },

        changeSearchContentDomHeight(height){
            this.searchContentDomHeight = height
            // console.log(this.searchContentDomHeight, 'store3333')
        },
    }
})

export {
    useLocale
} 